import { css, Theme } from '@emotion/react';

export const inlineCodePill = (theme: Theme) => css`
  background: ${theme.text.codeInlineBackground};
  color: ${theme.text.codeColor};
  border-radius: 999px;
  padding: 0.16em 0.6em;
  font-size: 0.84em;
  border: 1px solid ${theme.text.codeInlineBorder};
  box-shadow: ${theme.text.codeInlineShadow};
  white-space: nowrap;
`;
